module.exports = __webpack_public_path__ + "assets/img/00044.e020ff5f.png";